export default {
  appName: '萌牙',
  appDesc: '感謝您使用《萌牙》提供的服務！',
  authorizationTableiOS01: 'iOS 14.5 以上允許應用程式追蹤',
  authorizationTableiOS02: '用於提供個人化廣告',
  authorizationTableAndroid01: '允許應用程式存取網際網路',
  authorizationTableAndroid02: '用於從伺服器取得業務資料',
  authorizationTableAndroid03: '允許應用程式保持清醒',
  authorizationTableAndroid04: '用於防止應用休眠',
  companyName: '三河智士科技有限公司',
  contactEmail: "support{'@'}ifyyy.cn",
};
